import React from 'react'
import {Modal} from 'react-bootstrap'
import {toAbsoluteUrl} from '../../../_metronic/helpers'
import axios from 'axios'

function EventosCarruselItem(props) {
  console.log(props.evento.idElement)

  const url = 'https://puntosurgdl.com/backend/'

  const uploadFile = () => {
    const data = new FormData()

    if (document.getElementById(`file-${props.evento.idElement}`).files.length !== 0) {
      for (
        let i = 0;
        i < document.getElementById(`file-${props.evento.idElement}`).files.length;
        i++
      ) {
        data.append('file[]', document.getElementById(`file-${props.evento.idElement}`).files[i])
      }

      data.append('name', props.evento.idElement)

      axios
        .post(url + 'uploadNewEvento.php', data, {
          // receive two parameter endpoint url ,form data
        })
        .then(
          (res) => {
            // then print response status
            console.log(res.data)
            props.setEventosCarrusel(res.data.data)
          },
          (error) => {
            alert(error)
          }
        )
    } else {
      console.log('vacío')
    }
  }

  return (
    <div className='col-lg-4'>
      <div className='card card-custom overlay overflow-hidden card-evento'>
        <div className='card-body p-0'>
          <div className='overlay-wrapper'>
            <img
              src={props.evento.url}
              alt=''
              className='w-100 rounded home-promociones-1 img-promociones'
            />
          </div>
          <div className='overlay-layer bg-dark bg-opacity-10'>
            <div className='d-flex flex-grow-1 flex-center py-5'>
              <input
                type='file'
                id={`file-${props.evento.idElement}`}
                name={`file-${props.evento.idElement}`}
                className='input-image'
                onChange={() => uploadFile()}
                accept='image/*'
              />
              <input
                id='button'
                type='button'
                value='Cambiar...'
                className='btn btn-light-primary mr-2 btn-change'
                onClick={() => document.getElementById(`file-${props.evento.idElement}`).click()}
              />
              <input
                id='button'
                type='button'
                value='Eliminar'
                className='btn btn-danger'
                onClick={() => props.deleteEvento(props.evento.idElement)}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export {EventosCarruselItem}
